export default "__VITE_ASSET__092c7ffa__"